const COUNTRY_CODE_DECODE_MAP: Record<string, string> = {
    xu: 'ru',
    cq: 'by',
};

const COUNTRY_CODE_ENCODE_MAP: Record<string, string> = invertMapping(COUNTRY_CODE_DECODE_MAP);

function invertMapping(obj: Record<string, string>): Record<string, string> {
    return Object.fromEntries(Object.entries(obj).map(([k, v]) => [v, k]));
}

export function decodeCountryCode(code: string): string {
    return COUNTRY_CODE_DECODE_MAP[code.toLowerCase()] ?? code;
}

export function encodeCountryCode(code: string): string {
    return COUNTRY_CODE_ENCODE_MAP[code.toLowerCase()] ?? code;
}
